import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=12c3084c&scoped=true"
import script from "./ModalStaff.vue?vue&type=script&lang=js"
export * from "./ModalStaff.vue?vue&type=script&lang=js"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=12c3084c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3084c",
  null
  
)

export default component.exports